export default __webpack_public_path__ + "static/media/Future-Project.3704ac9c.png";